import { render, staticRenderFns } from "./PlanChangesModal.vue?vue&type=template&id=06cb3244&scoped=true&"
import script from "./PlanChangesModal.vue?vue&type=script&lang=js&"
export * from "./PlanChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./PlanChangesModal.vue?vue&type=style&index=0&id=06cb3244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb3244",
  null
  
)

export default component.exports